/**
 * 역할 코드(roles.code) — 관리자 판단·역할 표시명의 기준 (FR-PLT-RBAC).
 *
 * 권한은 표시 이름(roleName)이 아니라 코드로만 판단함. 코드는 기본 역할에만 있고(사용자가 만든 역할은 null)
 * 이름은 바뀔 수 있으므로 이름 문자열을 비교하지 않음. 화면 판단은 UX 보조이며 신뢰 경계는 서버(RoleCodes).
 */
import { SystemRole } from "@eqms/shared-types";
// 초기화 모듈(@/lib/i18n — react-i18next 연결)이 아닌 전역 i18next 인스턴스를 씀: 같은 싱글턴이라 현재 언어는 같고,
// react-i18next 를 mock 하는 테스트가 이 순수 헬퍼를 import 해도 초기화 코드를 끌어오지 않음.
import i18n from "i18next";

/** 전체 권한을 갖는 관리자 역할 코드 — 서버 RoleCodes.ADMIN 과 같은 범위. */
const ADMIN_ROLE_CODES: ReadonlySet<string> = new Set([
  SystemRole.COMPANY_ADMIN,
  SystemRole.SUPER_ADMIN,
]);

/** 관리자(회사 관리자·슈퍼관리자) 역할 코드인지. */
export function isAdminRoleCode(code: string | null | undefined): boolean {
  return code != null && ADMIN_ROLE_CODES.has(code);
}

/**
 * 역할 표시명 — 기본 역할은 코드로 번역(roles.builtin.<CODE>), 사용자가 만든 역할(코드 없음)은 입력한 이름 그대로.
 * 렌더 중 호출하면 현재 언어(i18n)를 바로 씀. useMemo 안에서 부를 때는 lng 로 화면 언어를 넘겨
 * 언어를 메모 의존성에 넣는다 — 안 넘기면 언어가 바뀌어도 메모된 라벨이 옛 언어로 남는다.
 */
export function roleLabel(
  code: string | null | undefined,
  name: string | null | undefined,
  lng?: string,
): string {
  if (code) return i18n.t(`roles.builtin.${code}`, { defaultValue: name ?? code, lng });
  return name ?? "";
}
